import cn from 'classnames';
import { ComponentPropsWithoutRef } from 'react';

import classes from './CustomModal.module.scss';

type THeaderProps = ComponentPropsWithoutRef<'div'>;

export function Header({
  className,
  children,
  ...props
}: THeaderProps) {
  return (
    <div
      {...props}
      className={cn(classes['custom-modal__header'], className)}
    >
      {children}
    </div>
  );
}
